var map = {
	"./map-step_1.webp": 813,
	"./map-step_2.webp": 814,
	"./map-step_3.webp": 815,
	"./map-step_4.webp": 816,
	"./map-step_5.webp": 817,
	"./map-step_6.webp": 818,
	"./star-map-step_1.webp": 819,
	"./star-map-step_2.webp": 820,
	"./star-map-step_3.webp": 821,
	"./star-map-step_4.webp": 822,
	"./star-map-step_5.webp": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1375;